module.exports = __webpack_public_path__ + "img/turbo-features12.409bdc0a.png";